import { useState } from 'react'
import { Banner, BannerType } from '@/app/entities/Banner'
import { getCardSize } from './utils'
import { CardContent, Card } from '@/view/components/ui/card'
import { Dialog, DialogContent } from '@/view/components/ui/dialog'
import { BannerForm } from './BannerForm'
import { BannerFormValues } from './useBannerForm'
import { DeleteBanner } from './DeleteBanner'

interface BannerCardProps {
  banner: Banner
  type: BannerType
  index: number
}

export const BannerCard = ({ type, banner, index }: BannerCardProps) => {
  const [isHovered, setIsHovered] = useState(false)
  const size = getCardSize(type)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const openEditModal = () => setIsEditModalOpen(true)
  const closeEditModal = () => setIsEditModalOpen(false)

  const bannerToFormValues = (banner: Banner): BannerFormValues => {
    return {
      link: banner.link ?? '',
      title: banner.title ?? '',
      description: banner.description ?? '',
      fileUrl: banner.uri ?? null,
      file: null,
      isYoutubeVideo: !!banner.videoUrl,
      videoUrl: banner.videoUrl ?? '',
      buttonLabel: banner.buttonLabel ?? '',
      isSellersApp: banner.isSellersApp,
      isTeamsApp: banner.isTeamsApp,
      isWebApp: banner.isWebApp,
    }
  }

  const getStripeColor = () => {
    if (type === BannerType.DASHBOARD_CARD) {
      if (index === 0) return 'bg-red-500'
    }
    return ''
  }

  const stripeColor = getStripeColor()

  const showDeleteButton = !(
    (type === BannerType.DASHBOARD_CARD && index === 0) ||
    [BannerType.INITIAL_PAGE].includes(type)
  )

  return (
    <>
      <Card
        style={{ width: size.width, height: size.height, flexShrink: 0 }}
        className="relative overflow-hidden rounded-xl"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={openEditModal}
      >
        {stripeColor && (
          <div
            className={`absolute -left-6 top-5 ${stripeColor} z-10 h-5 w-28`}
            style={{
              transform: 'rotate(-45deg)',
            }}
          >
            <p className="text-center text-xs text-white">
              {index === 0 ? 'Vendedores' : 'Equipes'}
            </p>
          </div>
        )}
        <CardContent className="h-full p-0">
          {banner.videoUrl ? (
            <img
              src="/mov.png"
              style={{ objectFit: 'contain', width: '100%', height: '100%' }}
              alt="banner-img"
            />
          ) : (
            <img
              src={`${import.meta.env.VITE_CDN_URL}${banner.uri}`}
              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
              alt="banner-img"
            />
          )}
        </CardContent>
        {isHovered && showDeleteButton && (
          <div className="absolute right-2 top-2">
            <DeleteBanner bannerIndex={index} type={type} />
          </div>
        )}
      </Card>
      <Dialog open={isEditModalOpen} onOpenChange={closeEditModal}>
        <DialogContent className="w-max max-w-none">
          <BannerForm
            onSuccess={closeEditModal}
            type={type}
            defaultValues={bannerToFormValues(banner)}
            bannerIndex={index}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
